<template>
  <div class="pages">
    <div class="pageContent infoPage">
      <div class="steps-background-wrapper" style="height: 0;padding:0;margin:0;visibility: hidden">
        <img class="steps-background" src="@/assets/img/stepsBg.png" alt="" />
      </div>
      <van-steps :active="stepActive" class="info-steps staff-steps" v-show="language === 'zh'" style="height: 0;padding:0;margin:0;visibility: hidden">
        <van-step class="staff-step">{{ $t('steps.person') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.contact') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.trip') }}</van-step>
      </van-steps>
      <van-steps :active="stepActive" class="info-steps staff-steps info-steps-English" v-show="language === 'en'" style="height: 0;padding:0;margin:0;visibility: hidden">
        <van-step class="staff-step">{{ $t('steps.person') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.contact') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.trip') }}</van-step>
      </van-steps>
      <div class="step-content" style="margin-top: 0; border-radius: 0">
        <person-info v-show="stepActive === 0" ref="personInfo" />
        <div class="information-box button-group" v-if="btnShow && status !== 'ENABLE'">
          <van-button :disabled="submitLoading" class="only-one" type="info" @click="goNext">{{ stepActive === 0 ? $t('form.label.submit') :
            $t('form.label.next') }}</van-button>
          <van-button plain type="info" v-show="stepActive > 0" @click="goPrev">{{ $t('form.label.previous') }}</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPersonInfo, submitInfo } from '@/api/guangzhou'
import { getConferenceInfo } from '@/api/conference'
import PersonInfo from './guangzhou/personInfo.vue'
import { mapGetters } from 'vuex'
import MonitorKeyboard from '@/utils/monitorKeyboard.js'

export default {
  name: 'guangzhouRegis',
  components: { PersonInfo },
  data() {
    return {
      stepActive: 0,
      guestInfo: true,
      language: 'zh',
      form: {
        conferenceId: this.$route.params.conferenceId
      },
      btnShow: true,
      submitLoading: false
    }
  },
  computed: {
    ...mapGetters(['status'])
  },
  mounted() {
    if (this.status === 'AUDIT') {
      this.finish()
      return
    }
    this.language = this.$i18n.locale
    if (this.status) {
      this.getPersonInfo()
    } else {
      this.$nextTick(() => {
        this.$refs.personInfo.initForm(this.form)
      })
    }
  },
  methods: {
    getPersonInfo() {
      getPersonInfo().then(res => {
        this.form = res.data
        this.$nextTick(() => {
          this.$refs.personInfo.initForm(this.form)
        })
      })
    },
    goNext() {
      if (this.stepActive < 3) {
        if (this.stepActive === 0) {
          if (this.submitLoading) {
            return
          }
          this.submitLoading = true
          this.$refs.personInfo.validate().then(() => {
            this.form = Object.assign({}, this.form, this.$refs.personInfo.form)
            if (this.status !== 'ENABLE') {
              getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(res => {
                if (this.$checkTimeBetween(res.data.guangzhouRegisterStartTime, res.data.guangzhouRegisterEndTime)) {
                  this.submitInfo()
                } else {
                  this.finishError()
                  this.$notify('注册已结束')
                }
              })
            } else {
              getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(res => {
                // if (this.$checkTimeBetween(res.data.modificationStartTime, res.data.modificationEndTime)) {
                  this.updateInfo()
                // } else {
                //   this.$notify(this.$t3('不在修改信息时间内', 'Not in the time of information modification'))
                // }
              })
            }
          })
        }
      }
    },
    goPrev() {
    },
    // 提交全部信息
    submitInfo() {
      submitInfo(this.form).then(res => {
        if (res.success) {
          this.$store.commit('user/SET_NEED_UPDATE_INFO', false)
          this.finish()
        } else {
          this.finishError()
        }
      }, err => {
        this.finishError()
      })
    },
    // 修改部分信息
    updateInfo() {
      this.updateCount = 0
    },
    finish() {
      this.submitLoading = false
      // TODO 跳转页面
      if (this.status === 'ENABLE') {
        this.$router.push('mediaSuccess')
      } else {
        this.$router.push('mediaConfirm')
      }
    },
    finishError() {
      this.submitLoading = false
    },
    // 监听软键盘是否弹出
    getKeyboardState() {
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {
        // alert('键盘弹出')
        this.btnShow = false
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
        // alert('键盘收起')
        this.btnShow = true
      })
    },
    beforeDestroy() {
      this.monitorKeyboard.onEnd();
    }
  }
}
</script>